import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import router from './router'
import './assets/tailwind.css'
import yingXian from './components/3D/Yingxian3Dmodel.vue'
import xuanKong from './components/3D/XuankongModel.vue'
import pingYao from './components/3D/PingYao3DModel.vue'
import jinCi from './components/3D/JinCi3DModel.vue'

const app = createApp(App)
app.component("yingXian",yingXian);
app.component("xuanKong",xuanKong);
app.component("pingYao",pingYao);
app.component("jinCi",jinCi);
app.use(ElementPlus)
app.use(router)
app.mount('#app')